import * as React from 'react';
import styled from 'styled-components';
import { Block, Icon, Text } from '../../../../../../../components';
import checkIcon from '../../../../../../../../assets/icons/icon-check-white.svg';

const ContainerProcedureBse: React.FC = (props) => {
  const { children } = props;
  return (
    <Block
      data-testid="cmp-bse-register"
      customized
      className="containerProcedureBse"
      padding="12px 0px 0px 0px"
    >
      <Block customized alignItems="flex-start" justifyContent="flex-start">
        {children}
      </Block>
    </Block>
  );
};

const BlockChildren = styled.div`
  margin: 8px 0px 0px 32px;
  width: 100%;
  // max-width: 540px:

  @media (min-width: 992px) {
    margin: 8px 0px 0px 40px;
  }
`;

const ContainerCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
  border-radius: 8px;

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }

  .complete__form {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 32px;

    .complete__form--btn {
      background: inherit;

      &:hover {
        background: #d5e5f0;
      }

      &:focus {
        background: #a8cbe2;
      }

      &:active {
        background: #a8cbe2;
      }
    }

    .complete__form--wrapper {
      display: flex;
      gap: 10px;
      width: 100%;
    }

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #161d1f;
    }
  }

  button {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    background: #5b36f2;
    border-radius: 4px;

    p {
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
    }

    &:hover {
      background: #745ef6;
    }

    &:focus {
      background: #4318cd;
    }

    &:active {
      background: #4318cd;
    }
  }

  .clsDisabled {
    pointer-events: none;
    cursor: none;
    color: #8090bb;
    background: #d5e5f0;
  }

  .container__sworndeclaration {
    display: flex;
    flex-direction: column;
    gap: 16px;
    & h1 {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #161d1f;
    }
  }
  .container__accept_statement {
    display: flex;
    flex-direction: row;
    gap: 8px;
    min-width: 230px;
  }

  .container__main_sworn {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  // @media (min-width: 360px) {
  //   .container__main_sworn {
  //     min-width: 230px;
  //   }
  // }

  @media (min-width: 640px) {
    .complete__form--btn {
      width: 100%;
    }
    button {
      width: 90px;
    }
    width: 100%;
  }
`;

const BlockBse = styled.div`
  // 552px
  // 28px 0px 45px 16px
  width: 100%;
  // padding: 28px 0px 52px 8px;
  @media (min-width: 992px) {
    width: 744px;
    margin: 0 auto;
  }

  @media (min-width: 1280px) {
    width: 744px;
  }
`;

const SubTitleCmp = styled.div`
  justify-content: flex-start;
  margin-bottom: 12px;
  .RowA {
    display: flex;
    padding-top: 6px;
  }

  .HiddenContent {
    visibility: hidden;
  }
  @media (min-width: 640px) {
    display: flex;
    align-items: flex-end;
    .HiddenContent {
      visibility: visible;
    }
  }
`;

const Step = (props: any) => {
  const {
    isFirst,
    name,
    order,
    date,
    isLast,
    children,
    disabled,
    // isCurrent,
    isComplete
  } = props;
  return (
    <Block customized className="step">
      <Block
        customized
        className="heading"
        flexDirection="row"
        alignItems="center"
      >
        <Block
          customized
          backgroundColor={isComplete ? '#5B36F2' : 'none'}
          //   border="2px solid #5B36F2"
          border={disabled ? '2px solid #8090BB' : '2px solid #5B36F2'}
          borderRadius="100%"
          maxWidth="32px"
          height="32px"
          alignItems="center"
          justifyContent="center"
          margin="0px 8px 8px 0px"
        >
          {!isComplete && (
            <Text
              fontWeight="700"
              fontSize="14px"
              lineHeight="20px"
              color={disabled ? '#8090BB' : '#5B36F2'}
            >
              {order}
            </Text>
          )}
          {isComplete && (
            <Icon customized alignItems="center" maxWidth="15px">
              <img src={checkIcon} alt="chevron" />
            </Icon>
          )}
        </Block>
        <Block
          customized
          padding={date && !isFirst ? '14px 0px 0px 0px' : '0px'}
          style={{ top: '-3px', position: 'relative' }}
        >
          <Text
            fontWeight="700"
            fontSize="14px"
            lineHeight="20px"
            color={disabled ? '#8090BB' : '#5B36F2'}
          >
            {name}
          </Text>
          {date && !isFirst && (
            <Text fontWeight="500" fontSize="11px" lineHeight="16px">
              {date}
            </Text>
          )}
        </Block>
      </Block>
      <Block
        customized
        className="content"
        flexDirection="row"
        alignItems="flex-start"
        margin="0px 0px 8px 0px"
        minHeight="24px"
        style={{ position: 'relative' }}
      >
        {!isLast && (
          <Block
            customized
            style={{ position: 'absolute' }}
            className="line"
            height="100%"
            alignItems="center"
            justifyContent="center"
            margin="0px 8px 0px 16px"
            maxWidth="2px"
          >
            <Block
              customized
              backgroundColor={!isComplete ? '#8090BB' : '#5B36F2'}
              height="100%"
              // minHeight="32px"
              maxWidth="2px"
            />
          </Block>
        )}
        <BlockChildren>{children}</BlockChildren>
      </Block>
    </Block>
  );
};

export { ContainerProcedureBse, Step, BlockBse, ContainerCard, SubTitleCmp };
